import { aiConfigItemMessages } from '@atlaskit/editor-common/ai-messages/ai-config-items';
import sharedMessages from '@atlassian/generative-ai-modal/utils/messages';

import { CONFIG_ITEM_KEYS } from '../../config-item-keys';
import type { EditorPluginAIConfigItemFactory } from '../../config-items';

export const freeGenerateAifc: EditorPluginAIConfigItemFactory = (options) => ({
	key: CONFIG_ITEM_KEYS.FREE_GENERATE_AIFC,
	// This is to avoid StateMachine `guard` check
	title: {
		id: 'free-generate-aifc-title',
		defaultMessage: 'Free Generate AIFC',
	},
	description: sharedMessages.aiUniversalLongCallToAction,
	promptHint: aiConfigItemMessages.freeGeneratePromptHint,
	adfPrompt: true,
	doNotHighlightDocWhenSelectionIsEmpty: true,
	insertOnEmptySelection: true,
	intentSchemaId: 'custom_free_generate_intent_schema.json',
	actions: {},
	getBackendModel: () => 'aifc-bridge',
});
